import React from 'react';
import "./css/NameChangePopup.css";


function NameChangePopup(props) {


     const close = (event) => {  
          event.preventDefault();
          if(event.target === event.currentTarget) {
               //close the whole popup with the function() in the parent
               props.setShowNameChangePopup(false);
          }        
     }


     return (
          <div className='nameChangePopupWide' onClick={close}>
               <div className='container'>
                    <div className='center'>
                         <p>Your username has been changed to: <span>{props.username}</span></p>
                         <button onClick={close}>Close</button>
                    </div>
               </div>
          </div>
     )
}

export default NameChangePopup
